import { colorPalette } from '../../colorPalette';
import { accordionSummaryClasses } from '@mui/material';
export const summaryStyle = () => ({
    border: `1px solid ${colorPalette.gray200}`,
});
export const titleStyle = () => ({
    color: colorPalette.gray900,
    fontSize: '16px',
    fontWeight: 600,
    fontFamily: 'RakutenSansUiSemiBold, serif',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '60vw',
});
export const subTitleStyle = () => ({
    color: colorPalette.gray500,
    fontSize: '14px',
    fontWeight: 400,
});
export const detailsContent = () => ({
    color: colorPalette.gray700,
    fontSize: '14px',
    fontWeight: 400,
    width: '100%',
});
export const customAccordionwithoutBorder = () => ({
    borderRadius: '0px ',
    borderLeft: '0px ',
    borderRight: '0px ',
});
export const contentStyle = () => ({
    marginLeft: '12px',
});
export const iconStyle = (props) => ({
    width: '32px',
    height: '32px',
    borderRadius: '4px',
    backgroundColor: props.iconBackgroundColor ? colorPalette[props.iconBackgroundColor] : colorPalette.gray700,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '12px',
});
export const customAccordionLiteStyle = () => ({
    borderRadius: '4px',
    border: `1px solid ${colorPalette.gray200}`,
    '&:hover': {
        boxShadow: `0 0 0 4px ${colorPalette.gray100}`,
    },
    '&.Mui-expanded:active': {
        border: `1px solid ${colorPalette.gray300}`,
    },
    '&:expanded': {
        color: 'red',
    },
    '&.Mui-expanded': {
        border: `1px solid ${colorPalette.gray800}`,
    },
    'detailsContent > * > Button': {
        width: '100%',
        marginTop: '12px',
    },
    '&:before': {
        display: 'none',
    },
    boxShadow: 'none',
    expanded: {
        border: `1px solid ${colorPalette.gray800}`,
        '&$expanded': {
            margin: 0,
        },
        '&:active': {
            border: `1px solid ${colorPalette.gray600}`,
        },
    },
});
export const customAccordionClassicStyle = () => ({
    borderRadius: '0px ',
    borderLeft: '0px ',
    borderRight: '0px ',
    borderTop: `1px solid ${colorPalette.gray200}`,
    borderBottom: `1px solid ${colorPalette.gray200}`,
    '&:before': {
        display: 'none',
    },
    boxShadow: 'none',
    '&.Mui-expanded': {
        borderTop: `1px solid ${colorPalette.gray800}`,
        borderBottom: `1px solid ${colorPalette.gray800}`,
    },
    '&.Mui-expanded:active': {
        borderTop: `1px solid ${colorPalette.gray300}`,
        borderBottom: `1px solid ${colorPalette.gray300}`,
    },
});
export const customSummaryStyle = (props) => {
    return {
        root: {
            width: '100%',
        },
        margin: 0,
        'detailsContent > * > Button': {
            width: '100%',
            marginTop: '12px',
        },
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        width: '100%',
        maxHeight: '60px',
        expanded: {
            '&$expanded': {
                maxHeight: 'initial',
                border: `1px solid ${colorPalette.gray800}`,
            },
        },
        backgroundColor: props.summaryColor ? colorPalette[props.summaryColor] : '',
        [`.${accordionSummaryClasses.expanded}`]: {
            margin: '12px 0',
            maxHeight: '60px',
        },
        [`.${accordionSummaryClasses.content}`]: {
            width: '100%',
        },
        expandIcon: {
            '&$expand': {
                transform: 'rotate(180deg)',
            },
        },
        content: {
            '&$expanded': {
                margin: '16px 0',
            },
        },
    };
};
export const generalSummary = () => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
});
export const customAccordionDetailsStyle = (props) => ({
    borderTop: props.isLite ? 'none' : `1px solid ${colorPalette.gray200}`,
    backgroundColor: props.detailsColor ? colorPalette[props.detailsColor] : '',
    padding: props.isLite ? '0 16px 16px 16px' : '16px',
});
